module.exports = __webpack_public_path__ + "fonts/iconfont.1e0114c3.ttf";